import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
/**
 * React component wrapper to apply transformations to builder-supplied props. Transformations
 * translate builder props to native component props so that builder components can have a more
 * user-friendly interface.
 * @param Component React component
 * @param transformations a map of transformations
 * @returns a React component with transformations applied
 */ export var withTransformations = function(Component, transformations) {
    return function withTransformations(props) {
        var ref = props.ref, rest = _object_without_properties(props, [
            "ref"
        ]);
        var extras = {};
        if (transformations) {
            for(var key in transformations){
                var transformation = transformations[key];
                if (transformation != null) {
                    extras[key] = transformation(rest);
                }
            }
        }
        return /*#__PURE__*/ _jsx(Component, _object_spread_props(_object_spread({}, rest, extras), {
            ref: ref
        }));
    };
};
